import { useEffect, useState } from 'react';

import { useTranslation } from '@crehana/i18n';
import { Col, Container, Row, Tab, Tabs } from '@crehana/ui';

import { useMediaQuery } from '@crehana/react-hooks';

import { ClientSideComponent } from '@crehana/web';

import ProductTab from './ProductTab';
import { PRODUCT_TABS } from './constants';
import { StyledH2 } from './Product.styles';

const Product: React.FC = () => {
  const { t } = useTranslation();
  const { matches: isSm } = useMediaQuery('sm');
  const [activeTab, setActiveTab] = useState(isSm ? 0 : 1);

  const handleTabChange = (tab: number) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (!isSm && document) {
      const tabs = document.getElementById('product-tabs');
      tabs?.scrollTo({ left: 100 });
    }
  }, []);

  return (
    <section className="pt-40">
      <Container>
        <Row>
          <Col className="md:flex items-center flex-col">
            <StyledH2 className="font-h2 text-center mx-32 text-32 leading-40 md:text-52 md:leading-64 sm:mx-auto">
              {t('PRODUCT_TITLE1')}
              <span className="text-primary-main"> {t('PRODUCT_TITLE2')} </span>
              {t('PRODUCT_TITLE3')}
            </StyledH2>
            <Tabs
              className="mt-36 mb-24 md:w-auto"
              onTabChange={handleTabChange}
              value={activeTab}
              htmlProps={{ id: 'product-tabs' }}
              size="s"
              scrollable
            >
              <Tab label={t('PRODUCT_TAB1')} />
              <Tab label={t('PRODUCT_TAB2')} />
              <Tab label={t('PRODUCT_TAB3')} />
              <Tab label={t('PRODUCT_TAB4')} />
            </Tabs>
          </Col>
        </Row>
      </Container>
      {PRODUCT_TABS.map((tab, i) => (
        <div
          key={`product-panel-${i}`}
          className={`${activeTab !== i ? 'hidden' : 'visible'}`}
        >
          <ProductTab {...tab} />
        </div>
      ))}
    </section>
  );
};

const ProductClientSide = () => {
  return (
    <ClientSideComponent>
      <Product />
    </ClientSideComponent>
  );
};

export default ProductClientSide;
